
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/events/calendar/competitions/view.css.ts.vanilla.css\",\"source\":\"Ll8xZDN6ZWI0MCB7CiAgd2lkdGg6IDEwMHB4Owp9Ci5fMWQzemViNDEgewogIHdpZHRoOiAxMDVweDsKfQouXzFkM3plYjQyIHsKICB3aWR0aDogMTAwcHg7Cn0KLl8xZDN6ZWI0MyB7CiAgd2lkdGg6IDE4MHB4Owp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/events/calendar/competitions/view.css.ts.vanilla.css\",\"source\":\"Ll8xZDN6ZWI0MCB7CiAgd2lkdGg6IDEwMHB4Owp9Ci5fMWQzemViNDEgewogIHdpZHRoOiAxMDVweDsKfQouXzFkM3plYjQyIHsKICB3aWR0aDogMTAwcHg7Cn0KLl8xZDN6ZWI0MyB7CiAgd2lkdGg6IDE4MHB4Owp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
